import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseRequest, BaseResponse } from '../shared';

interface getSumCashRequest extends BaseRequest {
  invId: string; //邀请活动ID
}

export interface InvSumRspVO {
  availCashTotal?: string; //可取金额
  availCashMonth?: string; //本月可提取金额  ,
  invSucCnt?: string; //  邀新成功人数 ,
  sumCash?: string; //  累计金额 ,
  availCashReal?: string; // 实际操作可提取金额 ,
  availCashWeek?: string; //本周可提取金额
  topWithdrawCash?: string; //最高可提现金额
}

interface getSumCashResponse extends BaseResponse {
  Data: InvSumRspVO;
}

/**
 * 获取邀请累计人数金额
 * @param params
 * @returns
 */
export async function getSumCash(request: getSumCashRequest, options?: DsbcApiOptions) {
  const url = await createDsbcApiUrl('/inv/getSumCash');
  return DsbcApi.fetch<getSumCashResponse>(url, request, true, options);
}
